import { useMemo } from 'react';
import { CHART_CATALOG } from '../catalog/chartCatalog';
import type { AnalyticsChart } from '../catalog/types';
import { selectChartsForSection } from '../model/selectChartsForSection';
import { useCurrentUserInProject } from 'store/user';
import { useBuildChartContext } from './useBuildChartContext';
import { useChartResultsMap } from './useChartResultsMap';

export function useInspectionAnalyticsCharts(): AnalyticsChart[] {
  const resultsMap = useChartResultsMap();
  const user = useCurrentUserInProject();
  const ctx = useBuildChartContext();

  return useMemo(
    () =>
      selectChartsForSection(
        CHART_CATALOG,
        resultsMap,
        user,
        ctx,
        'inspections'
      ),
    [resultsMap, user, ctx]
  );
}
